import { MdOutlineChevronRight } from 'react-icons/md';
import { AircraftIcon, CarGroundIcon, HotelIcon } from '@icons';
import { useMemo } from 'react';
import {
  AccommodationLegRouteRemovedLog,
  AviaLegRouteRemovedLog,
  GroundLegRouteRemovedLog,
  LogisticsChangeLogType,
  RemovedLegTypeEnum,
  SabreCommercialAviaLogLeg,
} from '@/api/apis/route';
import { ChangeLogAccommodationDates } from './ChangeLogAccommodationDates';
import { ChangeLogLocationName } from './ChangeLogLocationName';

const LOGS_WITH_LIST = [
  LogisticsChangeLogType.RouteRemovedLog,
  LogisticsChangeLogType.SuggestedRoutesAppliedLog,
  LogisticsChangeLogType.PartialSuggestedRoutesAppliedLog,
  LogisticsChangeLogType.LogisticsResourceSwappedLog,
  LogisticsChangeLogType.LogisticsResourceRemovedLog,
];

const renderIcon = (type: RemovedLegTypeEnum) => {
  switch (type) {
    case RemovedLegTypeEnum.AviaLegLog:
      return <AircraftIcon />;
    case RemovedLegTypeEnum.GroundLegLog:
      return <CarGroundIcon />;
    case RemovedLegTypeEnum.AccommodationLegLog:
    default:
      return <HotelIcon />;
  }
};

type LogsWithLocations = AviaLegRouteRemovedLog | GroundLegRouteRemovedLog | SabreCommercialAviaLogLeg;
type RouteLegsList = AccommodationLegRouteRemovedLog | AviaLegRouteRemovedLog | GroundLegRouteRemovedLog;

type RouteLocationsListItemProps = {
  logType: LogisticsChangeLogType;
  leg: RouteLegsList | SabreCommercialAviaLogLeg;
};

export const RouteLocationsListItem = ({ logType, leg }: RouteLocationsListItemProps) => {
  const legType = useMemo(() => {
    if (LOGS_WITH_LIST.includes(logType)) {
      return (leg as RouteLegsList).$type;
    }

    return RemovedLegTypeEnum.AviaLegLog;
  }, [logType, leg]);

  return (
    <div className="flex gap-2.5">
      <div className="h-5 w-4 flex items-center">{renderIcon(legType)}</div>
      {legType === RemovedLegTypeEnum.AccommodationLegLog && (
        <ChangeLogAccommodationDates
          checkInAt={(leg as AccommodationLegRouteRemovedLog).checkInAt}
          checkOutAt={(leg as AccommodationLegRouteRemovedLog).checkOutAt}
        />
      )}
      {legType !== RemovedLegTypeEnum.AccommodationLegLog && (
        <span className="leading-[normal]">
          <ChangeLogLocationName location={(leg as LogsWithLocations).departureLocation} />
          <MdOutlineChevronRight size={16} className="text-base-10 inline mx-1" />
          <ChangeLogLocationName location={(leg as LogsWithLocations).arrivalLocation} />
        </span>
      )}
    </div>
  );
};
